import { useContext } from "react";
import { Post } from "../utils/types";

import { PostInfoContext } from "../context/PostInfoContext";

export const usePostInfo = () => {
    const postInfo = useContext(PostInfoContext) || ({} as Post);

    return postInfo;
};